module.exports = __webpack_public_path__ + "static/img/02.3f72429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-cgM/02.png
// module id = jEyp
// module chunks = 1